// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"ProductLocation_paginationPageDropdownWrap__8DMtu","productLocation":"ProductLocation_productLocation__x2rBU","margin":"ProductLocation_margin__WKMeV"};